import React, { useEffect, useState } from "react";
import Button from "../../../Custom/Button/Button";

const notificationsMock = {
  "2026-03-09": [
    {
      id: 32,
      title: 'Стручни налаз за Струг 1 - MK53526 је истекао.',
      text: "Молимо вас да што пре додате нови стручни налаз за наведену машину.",
      seen: false,
      time: "2026-12-03 12:00"
    }
  ]
};

const style = {
  line: {
    borderBottom: "1px solid black",
    flex: 1
  },
  circle: {
    backgroundColor: "red",
    width: "20px",
    height: "20px",
    borderRadius: "100%"
  }
};

function SredstvaOpremaNotifikacije() {
  const [notifications, setNotifications] = useState({});
  const [expandedIds, setExpandedIds] = useState([]);

  useEffect(() => {
    if (notificationsMock) setNotifications(notificationsMock);
  }, [notificationsMock]);

  const handleExpand = (id, date) => {
    setExpandedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );

    if (notifications[date].find((notif) => notif.id === id && !notif.seen)) {
      setNotifications((prev) => ({
        ...prev,
        [date]: prev[date].map((notif) =>
          notif.id === id ? { ...notif, seen: true } : notif
        )
      }));
    }
  };

  return (
    <div
      style={{
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        backgroundColor: "#F9F9F9",
        height: "100%",
        overflowY: "auto"
      }}
    >
      {Object.keys(notifications).map((date) => (
        <div key={date}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "7px",
              fontSize: "18px"
            }}
          >
            <div style={style.line}></div>
            <div style={{ padding: "0 15px" }}>
              {date.split("-").reverse().join(".")}
            </div>
            <div style={style.line}></div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "7px" }}>
            {notifications[date].map((notif) => (
              <div>
                <div onClick={() => handleExpand(notif.id, date)}>
                  <Button
                    active={expandedIds.includes(notif.id)}
                    style={{
                      padding: "10px",
                      display: "flex",
                      justifyContent: "flex-start",
                      gap: "20px"
                    }}
                  >
                    {!notif.seen && <div style={style.circle}></div>}
                    <div>{notif.time.split(" ")[1]}</div>
                    <div>{notif.title}</div>
                  </Button>
                </div>
                {expandedIds.includes(notif.id) && (
                  <div style={{ border: "1px solid black", padding: "10px" }}>
                    {notif.text}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default SredstvaOpremaNotifikacije;
